// Handles form validation, required field highlighting, and add-to-cart button state
export function initProductFormValidation(context) {
    if (!context.addToCartButton || !context.cartForm) return;

    observeButtonChanges(context.addToCartButton);
    updateAddToCartButton(context);

    context.cartForm.addEventListener("change", (event) => handleRequiredElementsChange(event, context));
}

export function validateProductForm(event, ctx) {
    const valid = checkAllRequiredOptionsSelected(ctx);
    if (!valid) {
        highlightAllInvalidElements(ctx);
        scrollToElement(ctx.cartForm);
        event.preventDefault();
    }
    return valid;
}

function updateAddToCartButton(ctx) {
    const isValidForm =
        Array.from(ctx.requiredElements || []).every((element) => element.value.trim() !== "") &&
        ctx.cartForm.checkValidity();
    ctx.addToCartButton.classList.toggle("disabled", !isValidForm);
    ctx.addToCartButton.classList.toggle("wc-variation-selection-needed", !isValidForm);
}

function handleRequiredElementsChange(event, ctx) {
    if (event.target.matches("[required]")) {
        updateAddToCartButton(ctx);
        highlightInvalidElement(event.target, ctx);
    }
}

function checkAllRequiredOptionsSelected(ctx) {
    return Array.from(ctx.requiredElements || []).every((element) => element.value.trim() !== "");
}

function highlightInvalidElement(element, ctx) {
    const isValid = element.checkValidity();
    element.classList.toggle("not-selected", !isValid);
    if (ctx.customFabricInput && element === ctx.customFabricInput) {
        highlightFabricPicker(ctx);
    }
}

function highlightFabricPicker(ctx) {
    if (ctx.fabricPicker && ctx.customFabricInput) {
        ctx.fabricPicker.classList.toggle("not-selected", ctx.customFabricInput.value.trim() === "");
    }
}

function highlightAllInvalidElements(ctx) {
    let firstInvalid = null;
    (ctx.requiredElements || []).forEach((element) => {
        highlightInvalidElement(element, ctx);
        if (!firstInvalid && !element.checkValidity()) {
            firstInvalid = element;
        }
    });
    if (firstInvalid) {
        firstInvalid.reportValidity();
    }
}

function scrollToElement(element) {
    if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });
    }
}

function observeButtonChanges(button) {
    const originalButtonText = button.textContent;
    const labelSpan = document.getElementById("fgt-select-options-label");
    if (!labelSpan || !labelSpan.dataset.label) return;
    const selectOptionsLabel = labelSpan.dataset.label;
    const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
            if (mutation.type === "attributes" && mutation.attributeName === "class") {
                button.textContent = button.classList.contains("wc-variation-selection-needed")
                    ? selectOptionsLabel
                    : originalButtonText;
            }
        }
    });
    observer.observe(button, { attributes: true });
}
